import { asciiModule } from './asciiModule'

export default asciiModule
